// extracted by mini-css-extract-plugin
export default {"wrapper":"Tx-z","viewport":"Ux-z","container":"Vx-z","slide":"Wx-z"};